import { ActionTree } from 'vuex';
import { ApolloQueryResult } from 'apollo-client';
import { RootState } from '../store';
import { IFeedbackState } from '../stores/feedback.store';
import {
  mutationSetFeatures,
  mutationSetFeaturesSuccess,
  mutationSetFeaturesFailed,
} from '../mutations/feedback.mutations';
import { apolloClient } from '@/apollo';

import { IFeature, IFeaturesResponse } from '@/types/Feature';
import { featuresQuery } from '@/graphql/queries/features.queries';

export const actionLoadFeatures = 'loadFeatures';
export const actionLoadFeaturesSuccess = 'loadFeaturesSuccess';
export const actionLoadFeaturesFailed = 'loadFeaturesFailed';

export const actions: ActionTree<IFeedbackState, RootState> = {
  async [actionLoadFeatures]({ commit, dispatch }) {
    commit(mutationSetFeatures);

    try {
      const {
        data: { features = [] },
      }: ApolloQueryResult<IFeaturesResponse> = await apolloClient.query({
        query: featuresQuery,
      });

      dispatch(actionLoadFeaturesSuccess, features);
    } catch (e) {
      dispatch(actionLoadFeaturesFailed);
    }
  },
  async [actionLoadFeaturesSuccess]({ commit }, payload: IFeature[]) {
    commit(mutationSetFeaturesSuccess, payload);
  },
  async [actionLoadFeaturesFailed]({ commit }) {
    commit(mutationSetFeaturesFailed);
  },
};
